import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { portalApi, usePortal } from "@/lib/PortalContext";
import { formatErr } from "@/lib/api";

export default function PortalRedeem() {
  const nav = useNavigate();
  const { setPortalClient } = usePortal();
  const [status, setStatus] = useState("processing");
  const [err, setErr] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const next = params.get("next");
    if (!token) { setStatus("error"); setErr("Missing token"); return; }
    (async () => {
      try {
        await portalApi.post("/portal/redeem", { token });
        const me = await portalApi.get("/portal/me");
        setPortalClient(me.data);
        nav(next && next.startsWith("/portal") ? next : "/portal");
      } catch (e) {
        setStatus("error");
        setErr(formatErr(e) || "This link is invalid or has expired");
      }
    })();
  }, [nav, setPortalClient]);

  return (
    <div className="min-h-screen bg-[color:hsl(var(--background))] flex items-center justify-center px-6" data-testid="portal-redeem-page">
      <div className="text-center max-w-md">
        <div className="overline">Subtend Studio · Portal</div>
        <div className="font-serif text-4xl mt-4">
          {status === "processing" ? "Signing you in…" : "This link isn't working"}
        </div>
        {err && <div className="mt-4 text-sm text-muted-foreground">{err}</div>}
        {status === "error" && (
          <Link to="/" className="btn-outline mt-6 inline-flex">Return to homepage</Link>
        )}
      </div>
    </div>
  );
}
